var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C14.0373 0 16.7888 1.23217 18.7783 3.22168C20.7678 5.21121 22 7.96273 22 11C22 14.0373 20.7678 16.7888 18.7783 18.7783C16.7888 20.7678 14.0373 22 11 22C7.96273 22 5.21121 20.7678 3.22168 18.7783C1.23217 16.7888 0 14.0373 0 11C0 7.96273 1.23218 5.21121 3.22168 3.22168C5.21121 1.23218 7.96273 0 11 0ZM11 2C8.51447 2 6.26555 3.00597 4.63574 4.63574C3.00596 6.26555 2 8.51447 2 11C2 13.4855 3.00597 15.7345 4.63574 17.3643C6.26554 18.994 8.51448 20 11 20C13.4855 20 15.7345 18.994 17.3643 17.3643C18.994 15.7345 20 13.4855 20 11C20 8.51448 18.994 6.26554 17.3643 4.63574C15.7345 3.00597 13.4855 2 11 2ZM15.293 7.29297C15.6835 6.90244 16.3165 6.90244 16.707 7.29297C17.0976 7.68349 17.0976 8.31651 16.707 8.70703L10.707 14.707C10.3165 15.0976 9.68349 15.0976 9.29297 14.707L6.29297 11.707C5.90244 11.3165 5.90244 10.6835 6.29297 10.293C6.68349 9.90244 7.31651 9.90244 7.70703 10.293L10 12.5859L15.293 7.29297Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutlineIcon);
export default __webpack_public_path__ + "static/media/check-outline-icon.00a976bfbce7157a2e5e437fb1d82ce5.svg";
export { ForwardRef as ReactComponent };